// 1 rem = 16px
const typography = {
  fontFamily: "'Gilroy', sans-serif",
  h1: {
    fontWeight: 600,
    fontSize: "3.125rem",
    lineHeight: "3.5rem",
  },
  h2: {
    fontSize: "1.25rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
  },
  body1: {
    fontSize: "0.938rem",
    fontWeight: 300,
    lineHeight: "1.125rem",
  },
  body2: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1rem",
  },
  h3: {
    fontSize: "2.125rem",
    fontWeight: 600,
    lineHeight: 1.235,
  },
  h4: {
    fontSize: "1.5rem",
    fontWeight: 700,
    lineHeight: 1.334,
  },
  h5: {
    fontSize: "1.125rem",
    fontWeight: 600,
    lineHeight: 1.6,
  },
  h6: {
    fontSize: "1rem",
    fontWeight: 600,
    lineHeight: 1.5,
  },
  subtitle1: {
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "20px",
  },
  subtitle2: {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
  },
  subtitle3: {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "#828282",
    textTransform: "uppercase",
  },
  subtitle4: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#828282",
  },
  subtitle5: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: "#828282",
  },
  subtitle6: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "20px",
    color: "#050121",
  },
  subtitle7: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#050121",
  },
  subtitle8: {
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "32px",
    color: "#050121",
  },
  subtitle9: {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    letterSpacing: "1px",
    color: "#828282",
    textTransform: "uppercase",
  },
  success: {
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "22px",
    letterSpacing: "0.46px",
    color: "#027A48",
    textTransform: "uppercase",
  },
};

export default typography;
